module.exports = __webpack_public_path__ + "img/equityIcon2.be615dc4.png";